export default {
  '/math': { classColor: '_dark-blue' },
  '/coding': { classColor: '_red' },
  '/coding/junior': { classColor: '_light-yellow' },
  '/coding/pytpro': { classColor: '_dark-purple' },
  '/coding/pytstart': { classColor: '_purple' },
  '/coding/gamedesign': { classColor: '_yellow' },
  '/coding/websites': { classColor: '_dark-green' },
  '/coding/pc': { classColor: '_light-blue' },
  '/coding/videocontent': { classColor: '_light-pink' },
  '/coding/camp': { classColor: '_light-green' },
  '/coding/creative': { classColor: '_pink' },
  '/coding/graphicdesign': { classColor: '_orange' },
  '/coding/frontend': { classColor: '_orange' },
}
